module.exports = __webpack_public_path__ + "bbe1826b8febb046186d6eaf4ff160be.pdf";